import { AuthGuard } from '@/modules/auth/router/auth.guard';
import { OrganisationGuard } from '@/modules/auth/router/organisation.guard';
import multiguard from 'vue-router-multiguard';

export default [
    {
        name: 'organization:edit',
        path: '/organisation',
        component: () =>
            import(/* webpackChunkName: "organization" */ '@/modules/organization/views/EditOrganization.vue'),
        meta: { title: 'Organisation' },
        beforeEnter: multiguard([AuthGuard, OrganisationGuard]),
    },
    {
        name: 'organization-registration',
        path: '/organisation-registration',
        component: () =>
            import(/* webpackChunkName: "organization" */ '@/modules/organization/views/OrganizationRegistration.vue'),
        meta: { title: 'Organisation Registration' },
    },
    {
        name: 'unverified-organization',
        path: '/unverified-organisation',
        component: () =>
            import(/* webpackChunkName: "organization" */ '@/modules/organization/views/UnverifiedOrganization.vue'),
        meta: { title: 'Unverified Organisation' },
    },
];
